module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    },
    on: {
      "change": _vm.emitToParent
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [(Object.keys(_vm.variation.attributes).indexOf('color') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("color.label"),
      "columns": 3,
      "error": _vm.getError('attributes.color', _vm.variation.sku)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes['color']),
      expression: "variation.attributes['color']"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.attributes['color'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.attributes, 'color', $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.variation.attributes).indexOf('size') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("size.label"),
      "columns": 3,
      "error": _vm.getError('attributes.size', _vm.variation.sku)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes['size']),
      expression: "variation.attributes['size']"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.attributes['size'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.attributes, 'size', $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.variation.attributes).indexOf('voltage') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("voltage.label"),
      "columns": 3,
      "error": _vm.getError('attributes.voltage', _vm.variation.sku)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes['voltage']),
      expression: "variation.attributes['voltage']"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.variation.attributes['voltage'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.attributes, 'voltage', $event.target.value)
      }
    }
  })]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45865832","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/webcontinental/provide/Variation.vue
// module id = 3109
// module chunks = 0